var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart",style:({height:_vm.wapperHeight})},[_c('ve-line',{attrs:{"height":_vm.chartHeight,"data":_vm.chartData,"color":"#fff","textStyle":_vm.textStyle,"settings":_vm.chartSettings,"extend":_vm.percentExtend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }